"use client";

import { c as _c } from "react/compiler-runtime";
import PureHtml from "../custom/PureHtml";
import ProductGrid from "../product/ProductGrid";
import ProductCarousel from "../common/ProductCarousel";
import ProductCard from "../product/ProductCard";
import { Icon } from "@iconify/react";
import Link from "next/link";
import ProductSlideImageCarousel from "../common/ProductSlideImageCarousel";
import Image from "next/image";
import { Button } from "@mantine/core";
import { mediaUrl } from "@/lib/config/app";
export default function TopSellerSlider(t0) {
  const $ = _c(28);
  const {
    tps,
    labelMap
  } = t0;
  const stype = tps?.type || "slider";
  let t1;
  if ($[0] !== tps?.catpros) {
    t1 = tps?.catpros || [];
    $[0] = tps?.catpros;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const catpros = t1;
  const fimage = `${mediaUrl}${tps?.cat_image || catpros?.[0]?.featured_image || "noimage.png"}`;
  const t2 = tps?.heading;
  let t3;
  if ($[2] !== t2) {
    t3 = <h2 className="text-xl lg:text-2xl text-center lg:text-start">{t2}</h2>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = tps?.subtext;
  let t5;
  if ($[4] !== t4) {
    t5 = <PureHtml html={t4} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== catpros || $[7] !== fimage || $[8] !== labelMap || $[9] !== stype || $[10] !== tps?.cat_slug || $[11] !== tps?.heading) {
    t6 = stype === "slideimage" && <div className="grid grid-cols-1 lg:grid-cols-12 items-stretch gap-2"><div className="lg:col-span-2 py-2"><div className="bg-transparent border border-gray-200 shadow-lg h-full rounded-lg relative min-h-80 overflow-hidden"><Image src={fimage} alt={tps?.heading} width={360} height={360} className="object-cover z-0 w-full h-full opacity-100 object-top rounded-t-lg" /><div className="p-2 absolute bottom-1 z-1 w-full h-full flex flex-col items-center justify-end"><Link href={"/collections/" + tps?.cat_slug} className="flex items-center justify-center drop-shadow-lg"><Button fw={700} variant="white" leftSection={<Icon icon="mdi:arrow-right" />}>View All</Button></Link></div></div></div><div className="lg:col-span-10"><ProductSlideImageCarousel items={catpros} renderItem={product => <ProductCard product={product} labelMap={labelMap} />} /></div></div>;
    $[6] = catpros;
    $[7] = fimage;
    $[8] = labelMap;
    $[9] = stype;
    $[10] = tps?.cat_slug;
    $[11] = tps?.heading;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== catpros || $[14] !== labelMap || $[15] !== stype || $[16] !== tps?.cat_slug) {
    t7 = stype === "slider" && <div><ProductCarousel items={catpros} renderItem={product_0 => <ProductCard product={product_0} labelMap={labelMap} />} /><div className="viewall"><Link href={"/collections/" + tps?.cat_slug} className="font-heading flex items-center">View All<Icon icon="mdi:arrow-right" /></Link></div></div>;
    $[13] = catpros;
    $[14] = labelMap;
    $[15] = stype;
    $[16] = tps?.cat_slug;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== catpros || $[19] !== labelMap || $[20] !== stype) {
    t8 = stype === "grid" && <ProductGrid products={catpros} labelMap={labelMap} />;
    $[18] = catpros;
    $[19] = labelMap;
    $[20] = stype;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t3 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t9 = <section className="top-seller-slider py-2 lg:py-3 bg-gray-50"><div className="max-w-7xl mx-auto px-2">{t3}{t5}{t6}{t7}{t8}</div></section>;
    $[22] = t3;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}